import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '@env/environment';

/**
 * language factory for language switcher in application
 */
export function LanguageFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json?version=' + environment.VERSION);
}
